'use client'

import { useState } from 'react'

import { LanguageIcon } from '@/components/external/icons-material'
import { IconButton } from '@/components/external/material'

import { LanguageSelectionDialog } from './dialog/LanguageSelectionDialog'

export function LanguageSwitcher({ isMobile }: { isMobile?: boolean }) {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
      <IconButton data-testid="language-selector" aria-label="Change language" onClick={() => setDialogOpen(true)}>
        <LanguageIcon aria-hidden="true" />
      </IconButton>
      <LanguageSelectionDialog fullScreen={isMobile} open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  )
}
